document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('summary[data-url]').forEach(function (summary) {
    summary.addEventListener('click', function (e) {
      // 如果点击的不是箭头 svg，则跳转
      if (!e.target.closest('.svg-wrapper')) {
        window.location.href = this.dataset.url;
      }
    });
  });
});